import React, { Component, Fragment } from "react";
import DeleteModel from "./DeleteModel";
import UpdateModel from "./UpdateModel";
import EditModel from "./EditModel";

import AppContext from "../../../contexts/AppContext";
import InviteModel from "./InviteModel";

class List extends Component {
    state = {
        delete: false,
        update: false,
        item: {},
        invite: false,
    };

    /* delete */
    delete = (deleteType) => {
        return this.props.delete(this.props.item.id, deleteType);
    };
    toggleDelete = () => {
        this.setState({ delete: this.state.delete === true ? false : true });
    };

    /* update */
    toggleUpdate = () => {
        this.state.update === true
            ? this.setState({ update: false })
            : this.props
                  .getItem(this.props.item.id)
                  .then(response => {
                      console.log(response);
                      this.setState({ update: true, item: response.data });
                  })
                  .catch(error => {
                      this.context.state.handelError(error);
                  });
    };


    toggleInvite = () => {
        this.setState({ invite: this.state.invite === true ? false : true });
    }

    generateTableData = () => {
        let res=[];
        let tableData = this.props.item;
        const cols = this.props.defaultCols;
        for(var i =0; i < cols.length; i++){     
            if (cols[i] == 'user_type') {
                res.push(
                    <td key={'td_' + cols[i] + '_' + i}> {tableData[cols[i]] == 'external' ? 'Sourced' : 'Registered '}</td>
                )
            } else {
                res.push(
                    <td key={'td_' + cols[i] + '_' + i}> {
                        cols[i] =='state'? tableData['state_text']: tableData[cols[i]]
                        }</td>
                )
            }
            
        }
        return res;
    }

    render() {
        return (
            <Fragment>
                <tr>
				    {/*<td>{this.props.item.id}</td>*/}
                    {this.generateTableData()}
                    <td className="text-center mid overflow-visible">
                        <div className="writer-table-option d-inline-block py-2 px-3 position-relative">
						    <div className="menu">
						        <i className="fas fa-ellipsis-h"></i> 
						    </div>
                            <div className="sub-menu flex-column position-absolute">
                                <a
                                    target="_Blank"
                                    rel="noopener noreferrer"
                                    href={`/pw/` + this.props.item.url}
                                    type="button"
                                    className="p-2 text-left"
                                >
                                    Profile
                                </a>
                                <button
                                    onClick={this.toggleUpdate}
                                    type="button"
                                    className="p-2 text-left"
                                    >
                                        Manage
                                </button>
                                <button
                                    onClick={this.toggleDelete}
                                    type="button"
                                    className="p-2 text-left"
                                >
                                    Delete
                                </button>
                                {this.props.item.user_type == 'external' &&
                                    <button
                                        onClick={this.toggleInvite}
                                        type="button"
                                        className='p-2 text-left'
                                    >
                                        Invite Link
                                    </button>
                                }
                            </div>   
						</div>	
                        {this.state.delete === true ? (
                            <DeleteModel
                                delete={this.delete}
                                hideDelete={this.toggleDelete}
                            ></DeleteModel>
                        ) : null}
                        {(this.state.update === true && this.props.item.user_type == 'external') ? (
                                <EditModel
                                    item={this.state.item}
                                    update={this.props.update}
                                    hideUpdate={this.toggleUpdate}
                                    reload={this.props.reload}
                                ></EditModel>
                            
                        ) : null}
                        {(this.state.update === true && this.props.item.user_type == 'internal') ? (
                            <UpdateModel
                                item={this.state.item}
                                update={this.props.update}
                                hideUpdate={this.toggleUpdate}
                            ></UpdateModel>

                        ) : null}
                    </td>
                </tr>
                {this.state.invite === true ? (
                    <InviteModel
                        link={this.props.item.link}
                        hideInvite={this.toggleInvite}
                    ></InviteModel>
                ) : null}
            </Fragment>
        );
    }
}
List.contextType = AppContext;
export default List;



// WEBPACK FOOTER //
// ./src/components/admin/writers/List.js